import axios from "axios";
import { AdventureListMembership, CustomerListUpdate } from "@contracts/lists";
import { PageAdventureList } from "@contracts/pages";

// Manages Adventure Lists
export default {
  // ---Methods for any list use case---

  async addToList(communityId: string, listId: string, adventureId: string) {
    const { data } = await axios.put(`${import.meta.env.VITE_API_URL}/lists/${communityId}/list/${listId}/adventure/${adventureId}`);
    adventureListsByCommunity[communityId] = data;
  },

  async removeFromList(communityId: string, listId: string, adventureId: string) {
    const { data } = await axios.delete(`${import.meta.env.VITE_API_URL}/lists/${communityId}/list/${listId}/adventure/${adventureId}`);
    adventureListsByCommunity[communityId] = data;
  },

  // Updates an individual list (does NOT impact the list pointers, ex. homepage lists)
  async updateList(communityId: string, listToUpdate: PageAdventureList) {
    var allLists = adventureListsByCommunity[communityId] as Array<AdventureListMembership>;
    // Build the update payload
    const adventureIds = listToUpdate.adventures.map(i => i.id);
    const adventureIdsString = adventureIds.join(",");
    var payload = {
      id: listToUpdate.id,
      name: listToUpdate.name,
      includeAllAdventures: listToUpdate.includeAllAdventures,
      maxCount: listToUpdate.maxCount,
      randomize: listToUpdate.randomize,
      adventureIds: adventureIdsString,
    } as CustomerListUpdate;

    // update the local list
    var index = allLists?.findIndex(l => l.id === listToUpdate.id);
    if (index >= 0) {
      allLists[index].name = listToUpdate.name;
      allLists[index].memberIds = adventureIds;
    }

    const config = { headers: { "Content-Type": "application/json" } };
    await axios.put(`${import.meta.env.VITE_API_URL}/lists/${communityId}/lists/${listToUpdate.id}`, JSON.stringify(payload), config);
  },

  // Loads an individual list from the server
  async loadAdventureSummaryForList(communityId: string, listId: string): Promise<PageAdventureList> {
    const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/pages/${communityId}/lists/${listId}`);
    // Add to the cache
    this.syncListToCache(communityId, data);
    return data;
  },

  syncListToCache(communityId: string, singleList: PageAdventureList) {
    var customerLists = adventureListsByCommunity[communityId];
    if (!customerLists) {
      // Add the first list
      adventureListsByCommunity[communityId] = [singleList];
      return;
    }
    var index = customerLists.findIndex(l => l.id === singleList.id);
    if (index < 0) customerLists.push(singleList);
    else customerLists[index] = singleList;
  },

  // ---Integration specific---

  async createSiteIntegrationList(communityId: string, name: string): Promise<string> {
    // Server generates the Id
    const config = { headers: { "Content-Type": "application/json" } };
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/widget-admin/${communityId}/widgets`, JSON.stringify(name), config);
    // Add to the cache
    this.syncListToCache(communityId, response.data);

    return response.data.id;
  },

  async deleteSiteIntegrationList(communityId: string, listId: string) {
    await axios.delete(`${import.meta.env.VITE_API_URL}/widget-admin/${communityId}/widgets/${listId}`);
    // Remove from cache
    var allLists = adventureListsByCommunity[communityId] as Array<AdventureListMembership>;
    var index = allLists?.findIndex(l => l.id === listId);
    if (index >= 0) allLists.splice(index, 1);
  },
};

// DEPRECATED: I think this can be deleted.  We could probably really simplify this whole list code now (both client and server)
// ---DATA CACHE---
// NOTE!: This sticks around in memory so shouldn't re-load as the user navigates around the site.
const adventureListsByCommunity = {};
